<template>
  <v-col cols="12" sm="6" md="4" class="d-flex">
    <v-card class="elevation-1 flex-grow-1">
      <v-toolbar color="white">
        <v-toolbar-title class="text-md-subtitle-1">
          <span>Sales Funnel</span>
          <v-btn
            icon="fa-regular fa-circle-info"
            variant="text"
            aria-label="info"
            color="btncolor"
            @click="showToolTip"
          >
          </v-btn>
        </v-toolbar-title>
      </v-toolbar>

      <v-row v-if="loading" align="center" justify="center">
        <v-col class="pt-0">
          <div class="progress-container">
            <v-progress-circular
              :size="75"
              :width="8"
              class="my-auto"
              color="primary"
              indeterminate
            />
          </div>
        </v-col>
      </v-row>

      <v-tabs
        v-else
        v-model="activeTab"
        class="tab-container mb-4"
        color="primary"
      >
        <v-tab value="overall">Overall</v-tab>
        <v-tab value="seller">Seller</v-tab>
        <v-tab value="buyer">Buyer</v-tab>
        <v-tab value="rental">Rental</v-tab>
      </v-tabs>

      <v-window v-model="activeTab" style="background-color: unset">
        <!-- Overall -->
        <v-window-item value="overall">
          <v-list class="align-self-center">
            <v-list-item
              class="align-self-center"
              v-for="item in funnel"
              :key="item.title"
              @click="funnelStageClick(item)"
            >
              <v-row>
                <v-col cols="2" class="align-self-center">
                  <v-img
                    :src="item.icon"
                    max-height="25"
                    max-width="30"
                    contain
                  />
                </v-col>
                <v-col class="align-self-center">
                  <v-list-item-title
                    v-text="item.title"
                    class="font-weight-light sales-funnel-text align-self-center"
                  />
                </v-col>
                <v-col cols="2">
                  <v-list-item-action class="text-right justify-end">
                    <span
                      class="font-weight-medium text-h6 sales-funnel-data"
                      >{{ item.count }}</span
                    >
                  </v-list-item-action>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-window-item>
        <!-- Seller -->
        <v-window-item value="seller">
          <v-list>
            <v-list-item
              v-for="item in sellerFunnel"
              :key="item.title"
              @click="funnelStageClick(item)"
            >
              <v-row>
                <v-col cols="2">
                  <v-img
                    :src="item.icon"
                    max-height="25"
                    max-width="30"
                    contain
                  />
                </v-col>
                <v-col>
                  <v-list-item-title
                    v-text="item.title"
                    class="font-weight-light sales-funnel-text"
                  />
                </v-col>
                <v-col cols="2">
                  <v-list-item-action class="text-right justify-end">
                    <span
                      class="font-weight-medium text-h6 sales-funnel-data"
                      >{{ item.count }}</span
                    >
                  </v-list-item-action>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-window-item>
        <!-- Buyer -->
        <v-window-item value="buyer">
          <v-list dense>
            <v-list-item
              v-for="item in buyerFunnel"
              :key="item.title"
              @click="funnelStageClick(item)"
            >
              <v-row>
                <v-col cols="2">
                  <v-img
                    :src="item.icon"
                    max-height="25"
                    max-width="30"
                    contain
                  />
                </v-col>
                <v-col>
                  <v-list-item-title
                    v-text="item.title"
                    class="font-weight-light sales-funnel-text"
                  />
                </v-col>
                <v-col cols="2">
                  <v-list-item-action class="text-right justify-end">
                    <span
                      class="font-weight-medium text-h6 sales-funnel-data"
                      >{{ item.count }}</span
                    >
                  </v-list-item-action>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-window-item>
        <!-- Rental -->
        <v-window-item value="rental">
          <v-list dense class="rental-list">
            <v-list-item
              v-for="item in rentalFunnel"
              :key="item.title"
              @click="funnelStageClick(item)"
            >
              <v-row>
                <v-col cols="2">
                  <v-img
                    :src="item.icon"
                    max-height="25"
                    max-width="30"
                    contain
                  />
                </v-col>
                <v-col>
                  <v-list-item-title
                    v-text="item.title"
                    class="font-weight-light sales-funnel-text"
                  />
                </v-col>
                <v-col cols="2">
                  <v-list-item-action class="text-right justify-end">
                    <span
                      class="font-weight-medium text-h6 sales-funnel-data"
                      >{{ item.count }}</span
                    >
                  </v-list-item-action>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-window-item>
      </v-window>
    </v-card>
  </v-col>
</template>

<script>
import api from "@/services/api";
import { mapGetters } from "vuex";

export default {
  name: "console-overview-sales-funnel",
  components: {},
  props: {
    product: {
      type: String,
      default: "COMBINED",
    },
  },
  watch: {
    product() {
      this.parseProductData();
    },
  },
  data() {
    return {
      activeTab: null,
      statData: {},
      loading: false,
      funnel: [],
      sellerFunnel: [],
      buyerFunnel: [],
      rentalFunnel: [],
      toolTip: null,
      toolTipDialog: false,
    };
  },
  computed: {
    ...mapGetters("user", ["myBrokerage"]),
    ...mapGetters("auth", ["impBrokerage"]),
    // showRentalTab() {
    //   return this.product === "COMBINED" || this.product === "PRIMESTREET";
    // }
  },
  methods: {
    async loadSalesFunnel() {
      this.loading = true;
      this.funnel = [];
      this.sellerFunnel = [];
      this.buyerFunnel = [];

      let brokerage = this.myBrokerage;
      if (this.impBrokerage !== null) {
        brokerage = this.impBrokerage;
      }

      if (brokerage) {
        try {
          const { data } = await api.brokerage.stats(brokerage);
          this.statData = data;
          this.parseProductData();
        } catch (e) {
          console.log(e);
        } finally {
          this.loading = false;
        }
      } else {
        // TODO: Handle no brokerage set
        this.loading = false;
      }
    },
    buildOverallFunnel(
      receivedCount,
      spokenWith,
      shownHomes,
      madeOffer,
      underContract,
      closed,
      longTermHold,
    ) {
      this.funnel = [
        {
          icon: "/images/received.png",
          title: "Received",
          count: receivedCount,
          stage: "AWAITING_FOLLOWUP",
        },
        {
          icon: "/images/spoken_with.png",
          title: "Spoken With",
          count: spokenWith,
          stage: "SPOKEN_WITH",
        },
        {
          icon: "/images/shown_homes.png",
          title: "Met With/Shown Homes",
          count: shownHomes,
          stage: "MET_WITH_SELLER,SHOWN_HOMES",
        },
        {
          icon: "/images/made_offer.png",
          title: "Listed Homes / Made Offer",
          count: madeOffer,
          stage: "LISTED_HOME,OFFER_MADE",
        },
        {
          icon: "/images/under_contract.png",
          title: "Under Contract",
          count: underContract,
          stage: "UNDER_CONTRACT",
        },
        {
          icon: "/images/closed.png",
          title: "Closed",
          count: closed,
          stage: "CLOSED",
        },
        {
          icon: "/images/longtermhold.png",
          title: "Long Term Hold",
          count: longTermHold,
          stage: "LONG_TERM_HOLD",
        },
      ];
    },
    buildSellerFunnel(
      sellerReceived,
      sellerSpokenWith,
      sellerMetWithSeller,
      sellerListedHome,
      sellerUnderContract,
      sellerClosed,
      sellerLongTermHold,
    ) {
      this.sellerFunnel = [
        {
          icon: "/images/received.png",
          title: "Received",
          count: sellerReceived,
          stage: "AWAITING_FOLLOWUP",
          type: "SELLER",
        },
        {
          icon: "/images/spoken_with.png",
          title: "Spoken With",
          count: sellerSpokenWith,
          stage: "SPOKEN_WITH",
          type: "SELLER",
        },
        {
          icon: "/images/met_with_seller.png",
          title: "Met With Seller",
          count: sellerMetWithSeller,
          stage: "MET_WITH_SELLER",
          type: "SELLER",
        },
        {
          icon: "/images/made_offer.png",
          title: "Listed Home",
          count: sellerListedHome,
          stage: "LISTED_HOME",
          type: "SELLER",
        },
        {
          icon: "/images/under_contract.png",
          title: "Under Contract",
          count: sellerUnderContract,
          stage: "UNDER_CONTRACT",
          type: "SELLER",
        },
        {
          icon: "/images/closed.png",
          title: "Closed",
          count: sellerClosed,
          stage: "CLOSED",
          type: "SELLER",
        },
        {
          icon: "/images/longtermhold.png",
          title: "Long Term Hold",
          count: sellerLongTermHold,
          stage: "LONG_TERM_HOLD",
          type: "SELLER",
        },
      ];
    },
    buildBuyerFunnel(
      buyerReceived,
      buyerSpokenWith,
      buyerShownHomes,
      buyerOffersMade,
      buyerUnderContract,
      buyerClosed,
      buyerLongTermHold,
    ) {
      this.buyerFunnel = [
        {
          icon: "/images/received.png",
          title: "Received",
          count: buyerReceived,
          stage: "AWAITING_FOLLOWUP",
          type: "BUYER",
        },
        {
          icon: "/images/spoken_with.png",
          title: "Spoken With",
          count: buyerSpokenWith,
          stage: "SPOKEN_WITH",
          type: "BUYER",
        },
        {
          icon: "/images/shown_homes.png",
          title: "Shown Homes",
          count: buyerShownHomes,
          stage: "SHOWN_HOMES",
          type: "BUYER",
        },
        {
          icon: "/images/made_offer.png",
          title: "Made Offer",
          count: buyerOffersMade,
          stage: "OFFER_MADE",
          type: "BUYER",
        },
        {
          icon: "/images/under_contract.png",
          title: "Under Contract",
          count: buyerUnderContract,
          stage: "UNDER_CONTRACT",
          type: "BUYER",
        },
        {
          icon: "/images/closed.png",
          title: "Closed",
          count: buyerClosed,
          stage: "CLOSED",
          type: "BUYER",
        },
        {
          icon: "/images/longtermhold.png",
          title: "Long Term Hold",
          count: buyerLongTermHold,
          stage: "LONG_TERM_HOLD",
          type: "BUYER",
        },
      ];
    },
    buildRentalFunnel(
      rentalReceived,
      rentalSpokenWith,
      rentalShownHomes,
      rentalLeased,
      rentalLongTermHold,
    ) {
      this.rentalFunnel = [
        {
          icon: "/images/received.png",
          title: "Received",
          count: rentalReceived,
          stage: "AWAITING_FOLLOWUP",
          type: "BUYER",
        },
        {
          icon: "/images/spoken_with.png",
          title: "Spoken With",
          count: rentalSpokenWith,
          stage: "SPOKEN_WITH",
          type: "BUYER",
        },
        {
          icon: "/images/shown_homes.png",
          title: "Shown Homes",
          count: rentalShownHomes,
          stage: "SHOWN_HOMES",
          type: "BUYER",
        },
        {
          icon: "/images/closed.png",
          title: "Closed",
          count: rentalLeased,
          stage: "CLOSED",
          type: "BUYER",
        },
        {
          icon: "/images/longtermhold.png",
          title: "Long Term Hold",
          count: rentalLongTermHold,
          stage: "LONG_TERM_HOLD",
          type: "BUYER",
        },
      ];
    },
    parseProductData() {
      switch (this.product) {
        case "PRIMESTREET":
          this.parsePrimestreetOverallData(this.statData);
          this.parsePrimestreetSellerData(this.statData);
          this.parsePrimestreetBuyerData(this.statData);
          this.parsePrimestreetRentalData(this.statData);
          break;

        case "LEAD_GENIUS":
          this.parseLeadGeniusOverallData(this.statData);
          this.parseLeadGeniusSellerData(this.statData);
          this.parseLeadGeniusBuyerData(this.statData);
          this.parseLeadGeniusRentalData(this.statData);
          break;

        case "COMBINED":
          this.parseCombinedOverallData(this.statData);
          this.parseCombinedSellerData(this.statData);
          this.parseCombinedBuyerData(this.statData);
          this.parseCombinedRentalData(this.statData);
          break;
      }
    },
    parsePrimestreetOverallData(data) {
      // received count
      let receivedCount = data.received ? data.received : 0;

      // spoken with
      let spokenWith = data.spokenWith ? data.spokenWith : 0;

      // met and showed homes
      let shownHomes = data.shownHomes ? data.shownHomes : 0;
      shownHomes += data.metWithSeller ? data.metWithSeller : 0;

      // made offer
      let madeOffer = data.listedHome ? data.listedHome : 0;
      madeOffer += data.offersMade ? data.offersMade : 0;

      // under contract
      let underContract = data.underContract ? data.underContract : 0;

      // closed, updated to totalClosed per ticket 842
      let closed = data.totalClosed ? data.totalClosed : 0;

      // long term hold
      let longTermHold = data.longTermHold ? data.longTermHold : 0;

      this.buildOverallFunnel(
        receivedCount,
        spokenWith,
        shownHomes,
        madeOffer,
        underContract,
        closed,
        longTermHold,
      );
    },
    parsePrimestreetSellerData(data) {
      let sellerReceived = 0;
      let sellerSpokenWith = 0;
      let sellerMetWithSeller = 0;
      let sellerListedHome = 0;
      let sellerUnderContract = 0;
      let sellerClosed = 0;
      let sellerLongTermHold = 0;

      if (data.sellerFunnel) {
        const sellerData = data.sellerFunnel;
        // received count
        sellerReceived = sellerData.sellerReceived
          ? sellerData.sellerReceived
          : 0;

        // spoken with
        sellerSpokenWith = sellerData.sellerSpokenWith
          ? sellerData.sellerSpokenWith
          : 0;

        // met with seller
        sellerMetWithSeller = sellerData.sellerMetWithSeller
          ? sellerData.sellerMetWithSeller
          : 0;

        // listed home
        sellerListedHome = sellerData.sellerListedHome
          ? sellerData.sellerListedHome
          : 0;

        // under contract
        sellerUnderContract = sellerData.sellerUnderContract
          ? sellerData.sellerUnderContract
          : 0;

        // closed
        sellerClosed = sellerData.sellerClosed ? sellerData.sellerClosed : 0;

        // long term hold
        sellerLongTermHold = sellerData.sellerLongTermHold
          ? sellerData.sellerLongTermHold
          : 0;
      }

      this.buildSellerFunnel(
        sellerReceived,
        sellerSpokenWith,
        sellerMetWithSeller,
        sellerListedHome,
        sellerUnderContract,
        sellerClosed,
        sellerLongTermHold,
      );
    },
    parsePrimestreetBuyerData(data) {
      let buyerReceived = 0;
      let buyerSpokenWith = 0;
      let buyerShownHomes = 0;
      let buyerOffersMade = 0;
      let buyerUnderContract = 0;
      let buyerClosed = 0;
      let buyerLongTermHold = 0;

      if (data.buyerFunnel) {
        const buyerData = data.buyerFunnel;
        // received count
        buyerReceived = buyerData.buyerReceived ? buyerData.buyerReceived : 0;

        // spoken with
        buyerSpokenWith = buyerData.buyerSpokenWith
          ? buyerData.buyerSpokenWith
          : 0;

        // met with buyer and shown homes
        buyerShownHomes = buyerData.buyerShownHomes
          ? buyerData.buyerShownHomes
          : 0;

        // offers made
        buyerOffersMade = buyerData.buyerOffersMade
          ? buyerData.buyerOffersMade
          : 0;

        // under contract
        buyerUnderContract = buyerData.buyerUnderContract
          ? buyerData.buyerUnderContract
          : 0;

        // closed
        buyerClosed = buyerData.buyerClosed ? buyerData.buyerClosed : 0;

        // long term hold
        buyerLongTermHold = buyerData.buyerLongTermHold
          ? buyerData.buyerLongTermHold
          : 0;
      }

      this.buildBuyerFunnel(
        buyerReceived,
        buyerSpokenWith,
        buyerShownHomes,
        buyerOffersMade,
        buyerUnderContract,
        buyerClosed,
        buyerLongTermHold,
      );
    },
    parsePrimestreetRentalData(data) {
      let rentalReceived = 0;
      let rentalSpokenWith = 0;
      let rentalShownHomes = 0;
      let rentalLeased = 0;
      let rentalLongTermHold = 0;

      if (data.rentalFunnel) {
        const rentalData = data.rentalFunnel;
        // received count
        rentalReceived = rentalData.rentalAwaitingFollowup
          ? rentalData.rentalAwaitingFollowup
          : 0;

        // spoken with
        rentalSpokenWith = rentalData.rentalSpokenWith
          ? rentalData.rentalSpokenWith
          : 0;

        // met with buyer and shown homes
        rentalShownHomes = rentalData.rentalShownHomes
          ? rentalData.rentalShownHomes
          : 0;

        // under contract
        rentalLeased = rentalData.rentalLeased ? rentalData.rentalLeased : 0;

        // long term hold
        rentalLongTermHold = rentalData.rentalLongTermHold
          ? rentalData.rentalLongTermHold
          : 0;
      }

      this.buildRentalFunnel(
        rentalReceived,
        rentalSpokenWith,
        rentalShownHomes,
        rentalLeased,
        rentalLongTermHold,
      );
    },
    parseLeadGeniusOverallData(data) {
      // received count
      let receivedCount = data.leadGeniusReceived ? data.leadGeniusReceived : 0;

      // spoken with
      let spokenWith = data.leadGeniusSpokenWith
        ? data.leadGeniusSpokenWith
        : 0;

      // met and showed homes
      let shownHomes = data.leadGeniusShownHomes
        ? data.leadGeniusShownHomes
        : 0;
      shownHomes += data.leadGeniusMetWithSeller
        ? data.leadGeniusMetWithSeller
        : 0;

      // made offer
      let madeOffer = data.leadGeniusListedHome ? data.leadGeniusListedHome : 0;
      madeOffer += data.leadGeniusOffersMade ? data.leadGeniusOffersMade : 0;

      // under contract
      let underContract = data.leadGeniusUnderContract
        ? data.leadGeniusUnderContract
        : 0;

      // closed
      let closed = data.leadGeniusTotalClosed ? data.leadGeniusTotalClosed : 0;

      // long term hold
      let longTermHold = data.leadGeniusLongTermHold
        ? data.leadGeniusLongTermHold
        : 0;

      this.buildOverallFunnel(
        receivedCount,
        spokenWith,
        shownHomes,
        madeOffer,
        underContract,
        closed,
        longTermHold,
      );
    },
    parseLeadGeniusSellerData(data) {
      let sellerReceived = 0;
      let sellerSpokenWith = 0;
      let sellerMetWithSeller = 0;
      let sellerListedHome = 0;
      let sellerUnderContract = 0;
      let sellerClosed = 0;
      let sellerLongTermHold = 0;

      if (data.leadGeniusSellerFunnel) {
        const sellerData = data.leadGeniusSellerFunnel;
        // received count
        sellerReceived = sellerData.leadGeniusSellerReceived
          ? sellerData.leadGeniusSellerReceived
          : 0;

        // spoken with
        sellerSpokenWith = sellerData.leadGeniusSellerSpokenWith
          ? sellerData.leadGeniusSellerSpokenWith
          : 0;

        // met with seller
        sellerMetWithSeller = sellerData.leadGeniusSellerMetWithSeller
          ? sellerData.leadGeniusSellerMetWithSeller
          : 0;

        // listed home
        sellerListedHome = sellerData.leadGeniusSellerListedHome
          ? sellerData.leadGeniusSellerListedHome
          : 0;

        // under contract
        sellerUnderContract = sellerData.leadGeniusSellerUnderContract
          ? sellerData.leadGeniusSellerUnderContract
          : 0;

        // closed
        sellerClosed = sellerData.leadGeniusSellerClosed
          ? sellerData.leadGeniusSellerClosed
          : 0;

        // long term hold
        sellerLongTermHold = sellerData.leadGeniusSellerLongTermHold
          ? sellerData.leadGeniusSellerLongTermHold
          : 0;
      }

      this.buildSellerFunnel(
        sellerReceived,
        sellerSpokenWith,
        sellerMetWithSeller,
        sellerListedHome,
        sellerUnderContract,
        sellerClosed,
        sellerLongTermHold,
      );
    },
    parseLeadGeniusBuyerData(data) {
      let buyerReceived = 0;
      let buyerSpokenWith = 0;
      let buyerShownHomes = 0;
      let buyerOffersMade = 0;
      let buyerUnderContract = 0;
      let buyerClosed = 0;
      let buyerLongTermHold = 0;

      if (data.leadGeniusBuyerFunnel) {
        const buyerData = data.leadGeniusBuyerFunnel;
        // received count
        buyerReceived = buyerData.leadGeniusBuyerReceived
          ? buyerData.leadGeniusBuyerReceived
          : 0;

        // spoken with
        buyerSpokenWith = buyerData.leadGeniusBuyerSpokenWith
          ? buyerData.leadGeniusBuyerSpokenWith
          : 0;

        // met with buyer and shown homes
        buyerShownHomes = buyerData.leadGeniusBuyerShownHomes
          ? buyerData.leadGeniusBuyerShownHomes
          : 0;

        // offers made
        buyerOffersMade = buyerData.leadGeniusBuyerOffersMade
          ? buyerData.leadGeniusBuyerOffersMade
          : 0;

        // under contract
        buyerUnderContract = buyerData.leadGeniusBuyerUnderContract
          ? buyerData.leadGeniusBuyerUnderContract
          : 0;

        // closed
        buyerClosed = buyerData.leadGeniusBuyerClosed
          ? buyerData.leadGeniusBuyerClosed
          : 0;

        // long term hold
        buyerLongTermHold = buyerData.leadGeniusBuyerLongTermHold
          ? buyerData.leadGeniusBuyerLongTermHold
          : 0;
      }

      this.buildBuyerFunnel(
        buyerReceived,
        buyerSpokenWith,
        buyerShownHomes,
        buyerOffersMade,
        buyerUnderContract,
        buyerClosed,
        buyerLongTermHold,
      );
    },
    parseLeadGeniusRentalData(data) {
      let rentalReceived = 0;
      let rentalSpokenWith = 0;
      let rentalShownHomes = 0;
      let rentalLeased = 0;
      let rentalLongTermHold = 0;

      if (data.leadGeniusRentalFunnel) {
        const rentalData = data.leadGeniusRentalFunnel;
        // received count
        rentalReceived = rentalData.leadGeniusRentalAwaitingFollowup
          ? rentalData.leadGeniusRentalAwaitingFollowup
          : 0;

        // spoken with
        rentalSpokenWith = rentalData.leadGeniusRentalSpokenWith
          ? rentalData.leadGeniusRentalSpokenWith
          : 0;

        // met with buyer and shown homes
        rentalShownHomes = rentalData.leadGeniusRentalShownHomes
          ? rentalData.leadGeniusRentalShownHomes
          : 0;

        // under contract
        rentalLeased = rentalData.leadGeniusRentalLeased
          ? rentalData.leadGeniusRentalLeased
          : 0;

        // long term hold
        rentalLongTermHold = rentalData.leadGeniusRentalLongTermHold
          ? rentalData.leadGeniusRentalLongTermHold
          : 0;
      }

      this.buildRentalFunnel(
        rentalReceived,
        rentalSpokenWith,
        rentalShownHomes,
        rentalLeased,
        rentalLongTermHold,
      );
    },
    parseCombinedOverallData(data) {
      // received count
      let receivedCount = data.received ? data.received : 0;
      receivedCount += data.leadGeniusReceived ? data.leadGeniusReceived : 0;

      // spoken with
      let spokenWith = data.spokenWith ? data.spokenWith : 0;
      spokenWith += data.leadGeniusSpokenWith ? data.leadGeniusSpokenWith : 0;

      // met and showed homes
      let shownHomes = data.shownHomes ? data.shownHomes : 0;
      shownHomes += data.metWithSeller ? data.metWithSeller : 0;
      shownHomes += data.leadGeniusShownHomes ? data.leadGeniusShownHomes : 0;
      shownHomes += data.leadGeniusMetWithSeller
        ? data.leadGeniusMetWithSeller
        : 0;

      // made offer
      let madeOffer = data.listedHome ? data.listedHome : 0;
      madeOffer += data.offersMade ? data.offersMade : 0;
      madeOffer += data.leadGeniusListedHome ? data.leadGeniusListedHome : 0;
      madeOffer += data.leadGeniusOffersMade ? data.leadGeniusOffersMade : 0;

      // under contract
      let underContract = data.underContract ? data.underContract : 0;
      underContract += data.leadGeniusUnderContract
        ? data.leadGeniusUnderContract
        : 0;

      // closed
      let closed = data.totalClosed ? data.totalClosed : 0;
      closed += data.leadGeniusTotalClosed ? data.leadGeniusTotalClosed : 0;

      // long term hold
      let longTermHold = data.longTermHold ? data.longTermHold : 0;
      longTermHold += data.leadGeniusLongTermHold
        ? data.leadGeniusLongTermHold
        : 0;

      this.buildOverallFunnel(
        receivedCount,
        spokenWith,
        shownHomes,
        madeOffer,
        underContract,
        closed,
        longTermHold,
      );
    },
    parseCombinedSellerData(data) {
      let sellerReceived = 0;
      let sellerSpokenWith = 0;
      let sellerMetWithSeller = 0;
      let sellerListedHome = 0;
      let sellerUnderContract = 0;
      let sellerClosed = 0;
      let sellerLongTermHold = 0;

      if (data.sellerFunnel) {
        const sellerData = data.sellerFunnel;
        // received count
        sellerReceived += sellerData.sellerReceived
          ? sellerData.sellerReceived
          : 0;

        // spoken with
        sellerSpokenWith += sellerData.sellerSpokenWith
          ? sellerData.sellerSpokenWith
          : 0;

        // met with seller
        sellerMetWithSeller += sellerData.sellerMetWithSeller
          ? sellerData.sellerMetWithSeller
          : 0;

        // listed home
        sellerListedHome += sellerData.sellerListedHome
          ? sellerData.sellerListedHome
          : 0;

        // under contract
        sellerUnderContract += sellerData.sellerUnderContract
          ? sellerData.sellerUnderContract
          : 0;

        // closed
        sellerClosed += sellerData.sellerClosed ? sellerData.sellerClosed : 0;

        // long term hold
        sellerLongTermHold += sellerData.sellerLongTermHold
          ? sellerData.sellerLongTermHold
          : 0;
      }

      if (data.leadGeniusSellerFunnel) {
        const leadGeniusellerData = data.leadGeniusSellerFunnel;
        // received count
        sellerReceived += leadGeniusellerData.leadGeniusSellerReceived
          ? leadGeniusellerData.leadGeniusSellerReceived
          : 0;

        // spoken with
        sellerSpokenWith += leadGeniusellerData.sellerSpokenWith
          ? leadGeniusellerData.sellerSpokenWith
          : 0;

        // met with seller
        sellerMetWithSeller += leadGeniusellerData.metWithSeller
          ? leadGeniusellerData.metWithSeller
          : 0;

        // listed home
        sellerListedHome += leadGeniusellerData.leadGeniusSellerListedHome
          ? leadGeniusellerData.leadGeniusSellerListedHome
          : 0;

        // under contract
        sellerUnderContract += leadGeniusellerData.leadGeniusSellerUnderContract
          ? leadGeniusellerData.leadGeniusSellerUnderContract
          : 0;

        // closed
        sellerClosed += leadGeniusellerData.leadGeniusSellerClosed
          ? leadGeniusellerData.leadGeniusSellerClosed
          : 0;

        // long term hold
        sellerLongTermHold += leadGeniusellerData.leadGeniusSellerLongTermHold
          ? leadGeniusellerData.leadGeniusSellerLongTermHold
          : 0;
      }

      this.buildSellerFunnel(
        sellerReceived,
        sellerSpokenWith,
        sellerMetWithSeller,
        sellerListedHome,
        sellerUnderContract,
        sellerClosed,
        sellerLongTermHold,
      );
    },
    parseCombinedBuyerData(data) {
      let buyerReceived = 0;
      let buyerSpokenWith = 0;
      let buyerShownHomes = 0;
      let buyerOffersMade = 0;
      let buyerUnderContract = 0;
      let buyerClosed = 0;
      let buyerLongTermHold = 0;

      if (data.buyerFunnel) {
        const buyerData = data.buyerFunnel;
        // received count
        buyerReceived += buyerData.buyerReceived ? buyerData.buyerReceived : 0;

        // spoken with
        buyerSpokenWith += buyerData.buyerSpokenWith
          ? buyerData.buyerSpokenWith
          : 0;

        // met with buyer and shown homes
        buyerShownHomes += buyerData.buyerShownHomes
          ? buyerData.buyerShownHomes
          : 0;

        // offers made
        buyerOffersMade += buyerData.buyerOffersMade
          ? buyerData.buyerOffersMade
          : 0;

        // under contract
        buyerUnderContract += buyerData.buyerUnderContract
          ? buyerData.buyerUnderContract
          : 0;

        // closed
        buyerClosed += buyerData.buyerClosed ? buyerData.buyerClosed : 0;

        // long term hold
        buyerLongTermHold += buyerData.buyerLongTermHold
          ? buyerData.buyerLongTermHold
          : 0;
      }

      if (data.leadGeniusBuyerFunnel) {
        const leadGeniusBuyerData = data.leadGeniusBuyerFunnel;
        // received count
        buyerReceived += leadGeniusBuyerData.leadGeniusBuyerReceived
          ? leadGeniusBuyerData.leadGeniusBuyerReceived
          : 0;

        // spoken with
        buyerSpokenWith += leadGeniusBuyerData.leadGeniusBuyerSpokenWith
          ? leadGeniusBuyerData.leadGeniusBuyerSpokenWith
          : 0;

        // met with buyer and shown homes
        buyerShownHomes += leadGeniusBuyerData.leadGeniusBuyerShownHomes
          ? leadGeniusBuyerData.leadGeniusBuyerShownHomes
          : 0;

        // offers made
        buyerOffersMade += leadGeniusBuyerData.buyerOffersMade
          ? leadGeniusBuyerData.buyerOffersMade
          : 0;

        // under contract
        buyerUnderContract += leadGeniusBuyerData.leadGeniusBuyerUnderContract
          ? leadGeniusBuyerData.leadGeniusBuyerUnderContract
          : 0;

        // closed
        buyerClosed += leadGeniusBuyerData.leadGeniusBuyerClosed
          ? leadGeniusBuyerData.leadGeniusBuyerClosed
          : 0;

        // long term hold
        buyerLongTermHold += leadGeniusBuyerData.leadGeniusBuyerLongTermHold
          ? leadGeniusBuyerData.leadGeniusBuyerLongTermHold
          : 0;
      }

      this.buildBuyerFunnel(
        buyerReceived,
        buyerSpokenWith,
        buyerShownHomes,
        buyerOffersMade,
        buyerUnderContract,
        buyerClosed,
        buyerLongTermHold,
      );
    },
    parseCombinedRentalData(data) {
      let rentalReceived = 0;
      let rentalSpokenWith = 0;
      let rentalShownHomes = 0;
      let rentalLeased = 0;
      let rentalLongTermHold = 0;

      if (data.rentalFunnel) {
        const rentalData = data.rentalFunnel;
        // received count
        rentalReceived += rentalData.rentalAwaitingFollowup
          ? rentalData.rentalAwaitingFollowup
          : 0;

        // spoken with
        rentalSpokenWith += rentalData.rentalSpokenWith
          ? rentalData.rentalSpokenWith
          : 0;

        // met with buyer and shown homes
        rentalShownHomes += rentalData.rentalShownHomes
          ? rentalData.rentalShownHomes
          : 0;

        // under contract
        rentalLeased += rentalData.rentalLeased ? rentalData.rentalLeased : 0;

        // long term hold
        rentalLongTermHold += rentalData.rentalLongTermHold
          ? rentalData.rentalLongTermHold
          : 0;
      }

      if (data.leadGeniusRentalFunnel) {
        const lgRentalData = data.leadGeniusRentalFunnel;
        // received count
        rentalReceived += lgRentalData.leadGeniusRentalAwaitingFollowup
          ? lgRentalData.leadGeniusRentalAwaitingFollowup
          : 0;

        // spoken with
        rentalSpokenWith += lgRentalData.leadGeniusRentalSpokenWith
          ? lgRentalData.leadGeniusRentalSpokenWith
          : 0;

        // met with buyer and shown homes
        rentalShownHomes += lgRentalData.leadGeniusRentalShownHomes
          ? lgRentalData.leadGeniusRentalShownHomes
          : 0;

        // under contract
        rentalLeased += lgRentalData.leadGeniusRentalLeased
          ? lgRentalData.leadGeniusRentalLeased
          : 0;

        // long term hold
        rentalLongTermHold += lgRentalData.leadGeniusRentalLongTermHold
          ? lgRentalData.leadGeniusRentalLongTermHold
          : 0;
      }

      this.buildRentalFunnel(
        rentalReceived,
        rentalSpokenWith,
        rentalShownHomes,
        rentalLeased,
        rentalLongTermHold,
      );
    },
    funnelStageClick(funnel) {
      console.log(funnel);

      let params = {
        s: funnel.stage,
      };

      if (funnel.type) {
        params.t = funnel.type;
      }

      console.log(params);

      this.$router.push({ name: "my-referrals", query: params });
    },
    showToolTip() {
      this.$emit("toolTip", "OverviewSalesFunnelToolTip");
    },
  },
  mounted() {
    this.loadSalesFunnel();
  },
};
</script>

<style scoped>
/*See ConsoleOverview for non-scoped classes*/
.tab-container {
}
.tab-container >>> .v-tab {
  font-size: 14px;
  text-transform: none;
  min-width: unset;
  letter-spacing: unset;
}
.tab-container >>> .v-slide-group__prev {
  /*display: none !important;*/
  visibility: unset !important;
}

.rental-list {
  margin-bottom: 112px;
}

.progress-container {
  width: 100%;
  min-height: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sales-funnel-text {
  font-size: 14px !important;
}
.sales-funnel-data {
  color: black;
}
</style>
